export const SELECTEDACCOUNTS = 'checkBox';
export const CURRENTSELECTION = 'currentSelection';
